import { Pipe, PipeTransform } from '@angular/core';
import { isMoment, Moment } from 'moment';
import moment from 'moment';
import { tz } from 'moment-timezone';

type DateOrStringOrMoment = string | Date | Moment;
@Pipe({
    name: 'gtCalendarTime',
    standalone: true
})
export class GtCalendarTimePipe implements PipeTransform {
  private _timeZone: string;
  public transform(date, dateFormat = 'DD MMM, YYYY', timeFormat = 'hh:mm A'): string {
    const currentDate = this.toMoment(date);
    return moment(currentDate).calendar(null, {
      // TODO: we need tab space between date and time
      sameDay: `[Today],\u00A0 ${timeFormat}`,
      nextDay: `[Tomorrow],\u00A0 ${timeFormat}`,
      lastDay: `[Yesterday],\u00A0 ${timeFormat}`,
      nextWeek: `${dateFormat}\u00A0 ${timeFormat}`,
      lastWeek: `${dateFormat}\u00A0 ${timeFormat}`,
      sameElse: `${dateFormat}\u00A0 ${timeFormat}`
    });
  }

  public toMoment(date: DateOrStringOrMoment): Moment {
    if (!isMoment(date)) {
      date = this.parse(date);
    }
    return date;
  }

  public parse(date: string | Date, timeZone = this.timeZone): Moment {
    try {
      return tz(date, timeZone);
    } catch (error) {
     console.error('date parse error');
    }
  }

  public get timeZone() {
    return this._timeZone || tz.guess();
  }
}
